import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Zap, Sparkles, ShieldCheck, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";

export default function AIPractice() {
  const navigate = useNavigate();
  const [count, setCount] = useState(null);

  useEffect(() => {
    api.get("/pyq", { params: { source: "AI_GENERATED", limit: 1 } }).then((r) => setCount(r.data.total)).catch(() => setCount(0));
  }, []);

  return (
    <div className="mx-auto max-w-3xl" data-testid="ai-practice">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        className="overflow-hidden rounded-3xl border border-violet-200 bg-gradient-to-br from-violet-50 to-blue-50 p-8 sm:p-10">
        <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-violet-600 text-white"><Zap className="h-7 w-7" /></span>
        <h1 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">AI-Generated Questions</h1>
        <p className="mt-3 max-w-xl text-muted-foreground">
          Practise fresh, exam-authentic questions created by our VIGS engine and verified by expert teachers before they reach you.
        </p>

        <div className="mt-6 flex flex-wrap gap-4 text-sm">
          <span className="inline-flex items-center gap-1.5 text-violet-700"><Sparkles className="h-4 w-4" /> Grounded in real PYQs</span>
          <span className="inline-flex items-center gap-1.5 text-emerald-700"><ShieldCheck className="h-4 w-4" /> Expert-verified</span>
        </div>

        <div className="mt-8">
          {count === null ? (
            <Skeleton className="h-11 w-48 rounded-xl" />
          ) : count > 0 ? (
            <>
              <p className="mb-3 text-sm font-medium">{count} AI question{count === 1 ? "" : "s"} ready to practise.</p>
              <Button onClick={() => navigate("/student/session?source=AI_GENERATED&mode=UNTIMED")} data-testid="start-ai-btn" className="rounded-xl bg-violet-600 px-6 hover:bg-violet-700">
                Start AI practice <ArrowRight className="ml-1.5 h-4 w-4" />
              </Button>
            </>
          ) : (
            <div className="rounded-xl border border-violet-200 bg-white/60 p-5">
              <p className="text-sm font-medium">No AI questions published yet</p>
              <p className="mt-1 text-sm text-muted-foreground">Once an admin generates and a teacher approves questions, they'll appear here. In the meantime, try Previous Year Questions.</p>
              <Button variant="outline" onClick={() => navigate("/student/practice/pyq")} className="mt-4 rounded-xl">Browse PYQ instead</Button>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
}
